'use client';

import type {
  AdaptiveScanningResumeMode,
  AdaptiveScanningTargetBlockReason,
} from '@terra/shared-contracts-applications';
import { useState } from 'react';
import { useResumeAdaptiveScanning } from '../../../hooks/api/useResumeAdaptiveScanning';

export function useAdaptiveScanningResume({
  applicationId,
}: {
  applicationId: string;
}) {
  const resumeMutation = useResumeAdaptiveScanning({ applicationId });
  const [isResumeOpen, setIsResumeOpen] = useState(false);

  const confirmResume = ({
    mode,
    rerunBlockedReasons,
  }: {
    mode: AdaptiveScanningResumeMode;
    rerunBlockedReasons: AdaptiveScanningTargetBlockReason[];
  }) =>
    resumeMutation.mutate(
      {
        mode,
        rerunBlockedReasons:
          rerunBlockedReasons.length > 0 ? rerunBlockedReasons : undefined,
        skipVerification: false,
      },
      {
        onSuccess: () => {
          setIsResumeOpen(false);
        },
      },
    );

  return {
    isResumeOpen,
    setIsResumeOpen,
    isResuming: resumeMutation.isPending,
    confirmResume,
  };
}
